var App = App || {};

App.xQuiz = (function ($) {
    'use strict';

    function init() {

        $(".quiz").each(function () {

            var $this = $(this);
            var $reset = $this.find(".quiz__reset button");
            var $questions = $this.find(".quiz__questions").children(".quiz__question");
            var questionCount = $questions.length + 1;

            var questionWhich = 1;
            questionShow($this, questionCount, questionWhich);

            $reset.click(function () {
                questionWhich = 1;
                questionShow($this, questionCount, questionWhich);
            });

            $questions.find(".quiz__question-yesno").find("button[data-pass='true']").click(function () {
                questionWhich++;
                questionShow($this, questionCount, questionWhich);
            });

            $questions.find(".quiz__question-yesno").find("button[data-pass='false']").click(function () {
                questionWhich = 0;
                questionShow($this, questionCount, questionWhich);
            });
        });

    }

    function questionShow($this, questionCount, questionWhich) {
        var $reset = $this.find(".quiz__reset button");

        if (questionWhich <= 0) {
            $reset.removeAttr("disabled");
            $this.find(".quiz__questions").hide();
            $this.find(".quiz__results").show().find(".ineligible").show().siblings(".eligible").hide();
        }
        else if (questionWhich > 0 && questionWhich < questionCount) {

            if (questionWhich > 1) {
                $reset.removeAttr("disabled");
            }
            else {
                $reset.Attr("disabled");
            }

            $this.find(".quiz__questions").show();
            $this.find(".quiz__results").hide();

            var question = $this.find(".quiz__questions").children(".quiz__question:nth-child(" + questionWhich + ")")
            question.show().siblings().hide();

        }
        else if (questionWhich >= questionCount) {
            $reset.removeAttr("disabled");
            $this.find(".quiz__questions").hide();
            $this.find(".quiz__results").show().find(".eligible").show().siblings(".ineligible").hide();
        }
    }

    return {
        init: init
    };

})(jQuery);

App.Quiz = (function ($) {
    'use strict';

    var $quiz,
        $reset,
        $questions,
        $results;

    function init() {
        $quiz = $('.quiz');
        $reset = $quiz.find('.quiz__reset button');
        $questions = $quiz.find('.quiz__question');
        $results = $quiz.find('.quiz__result');

        $questions.first().show();

        $questions.on('click', '.quiz__question-yesno button', function (e) {
            var nodeGuid = $(e.target).data('target');
            e.preventDefault();

            goToNext(nodeGuid);
        });

        $reset.on('click', reset);
    }

    function goToNext(nodeGuid) {
        $.merge($questions, $results).hide();
        $quiz.find('div[data-nodeguid="' + nodeGuid + '"]').show();
        $reset.removeAttr('disabled');
    }

    function reset() {
        $.merge($questions, $results).hide();
        $questions.first().show();
        $reset.attr('disabled', true);
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Quiz.init();
});